import React from 'react';
import '../App.css';
import Header from './Header';

function PrivacyPolicy() {
    return (
        <div className="privacy-policy-page">
            <Header />
            <div className="privacy-policy-container">
                <div className="privacy-policy-sidebar">
                    <div className="sidebar-header">Legal</div>
                    <ul className="sidebar-nav">
                        <li><a href="#introduction">Introduction</a></li>
                        <li><a href="#information-collect">Information We Collect</a></li>
                        <li><a href="#how-we-use">How We Use and Share Your Information</a></li>
                        <li><a href="#cookies">Cookies and Similar Technologies</a></li>
                        <li><a href="#retention">Retention of Your Information</a></li>
                        <li><a href="#security">Security of Your Information</a></li>
                    </ul>
                </div>
                
                <div className="privacy-policy-content">
                    <h1>Privacy Policy</h1>
                    <p className="last-updated">Last Updated: March 01, 2025</p>
                    
                    <hr className="policy-divider" />
                    
                    <section id="introduction">
                        <h2>Introduction</h2>
                        <p>This Privacy Notice for Quokka LTD ('we', 'us', or 'our'), describes how and
                        why we might access, collect, store, use, and/or share ('process') your
                        personal information when you use our services ('Services'), including
                        when you:</p>
                        
                        <ul>
                            <li>Visit our website at <a href="http://www.wearequokka.com">http://www.wearequokka.com</a>, or any website of
                            ours that links to this Privacy Notice</li>
                            <li>Engage with us in other related ways, including any sales,
                            marketing, or events</li>
                        </ul>
                        
                        <p>This Privacy Policy is not a contract and does not create any contractual rights or
                        obligations. We will update this Privacy Policy from time to time to reflect our
                        practices and recommend that you periodically review this Privacy Policy.</p>
                        
                        <p>If we make material changes to this Privacy Policy, we will make reasonable
                        attempts to notify you before they become effective. If you have questions about
                        this Privacy Policy, please feel free to contact us (our contact information is at the
                        end of this Privacy Policy).</p>
                    </section>
                    
                    <section id="information-collect">
                        <h2>Information We Collect</h2>
                        <p>When you visit, use, or navigate our Services, we may process personal information depending on
                        how you interact with us and the Services, the choices you make, and the
                        products and features you use.</p>
                        
                        <p>The personal information that we collect depends on the context of your interactions with us and the
                        Services, the choices you make, and the products and features you use.
                        The personal information we collect may include the following:</p>
                        <ul>
                            <li>Names</li>
                            <li>Phone numbers</li>
                            <li>Email addresses</li>
                            <li>Job titles</li>
                        </ul>
                        
                        <p><strong>Sensitive Information.</strong> We do not process sensitive information.</p>
                        
                        <p><strong>Payment Data.</strong> We may collect data necessary to process your payment if you choose to make purchases, such as your payment instrument number, and the security code associated with your payment instrument. All payment data is handled and stored by Stripe. You may find their privacy notice link(s) here: <a href="https://stripe.com/gb/privacy">https://stripe.com/gb/privacy</a>.</p>
                    </section>
                    
                    <section id="how-we-use">
                        <h2>How We Use and Share Your Information</h2>
                        <p>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</p>
                        <ul>
                            <li>To facilitate account creation and authentication and otherwise manage user accounts</li>
                            <li>To deliver and facilitate delivery of services to the user</li>
                            <li>To save or protect an individual's vital interest</li>
                        </ul>
                        
                        <p>We may share information in specific situations described in this section and/or with the following third parties:</p>
                        <ul>
                            <li><strong>Business Transfers.</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.</li>
                        </ul>
                    </section>
                    
                    <section id="cookies">
                        <h2>Cookies and Similar Technologies</h2>
                        <p>We may use cookies and similar tracking technologies (like web beacons and pixels) to collect and store your information. Some online tracking technologies help us maintain the security of our Services and your account, prevent crashes, fix bugs, save your preferences, and assist with basic site functions.</p>
                        
                        <p>We also permit third parties and service providers to use online tracking technologies on our Services for analytics and advertising, including to help manage and display advertisements, to tailor advertisements to your interests, or to send abandoned shopping cart reminders (depending on your communication preferences).</p>
                    </section>
                    
                    <section id="retention">
                        <h2>Retention of Your Information</h2>
                        <p>We will only keep your personal information for as long as it is necessary for the purposes set out in this Privacy Notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements). No purpose in this notice will require us keeping your personal information for longer than the period of time in which users have an account with us.</p>
                        
                        <p>When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymise such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.</p>
                    </section>
                    
                    <section id="security">
                        <h2>Security of Your Information</h2>
                        <p>We have implemented appropriate and reasonable technical and organisational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorised third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information.</p>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
